export const exportConstants = {
    EXPORT_DATA_REQUEST: 'EXPORT_DATA_REQUEST',
    EXPORT_DATA_SUCCESS: 'EXPORT_DATA_SUCCESS',
    EXPORT_DATA_FAILURE: 'EXPORT_DATA_FAILURE',
};
